<template>
  <div class='notfoundBody'>
        <!-- Load page -->
        <div class="animationload">
            <div class="loader">
            </div>
        </div>
        <!-- End load page -->

        <!-- Content Wrapper -->
        <div id="wrapper" style="margin-top: 88px;">
            <div class="container">

                <!-- brick of wall -->
                <div class="brick"></div>
                <!-- end brick of wall -->

                <!-- Number -->
                <div class="number">
                    <div class="four" :style="number4" :data-image="backgroundImage"></div>
                    <div class="zero" :style="number0" :data-image="backgroundImage">
                        <div class="nail"></div>
                    </div>
                    <div class="four" :style="number4" :data-image="backgroundImage"></div>
                </div>
                <!-- end Number -->

                <!-- Info -->
                <div class="info" style='color:#fff'>
                    <h2 style='color:#f6c338'>Algo está errado</h2>
                    <p>A página que você estava procurando foi movida, removida, renomeada ou pode nunca ter existido.</p>
                    <router-link to="/home" class="btn-404">Ir ao Inicio</router-link>
                </div>
                <!-- end Info -->

            </div>
            <!-- end container -->
        </div>
        <!-- end Content Wrapper -->

        <!-- Footer -->
        <footer id="footer">
            <div class="container">
                <!-- Worker -->
                <div class="worker"></div>
                <!-- Tools -->
                <div class="tools"></div>
            </div>
            <!-- end container -->
        </footer>
        <!-- end Footer -->
  </div>
</template>

<script>
  export default {

    props: {
      numero4: {
        type: String,
        default: '/img/four.png'
      },
      numero0: {
        type: String,
        default: '/img/zero.png'
      }
    },
    data () {
      return {
        backgroundImage:null,
      }
    },
    
    computed: {
      number4 () {
        return {
          backgroundImage: `url(${this.numero4})`
        }
      },
      number0 () {
        return {
          backgroundImage: `url(${this.numero0})`
        }
      }
    }
  }

</script>
<style>
   .notfoundBody {
    position: fixed;
    height: 100%;
    width: 100%;
    background-color: #232a4b !important;
   }
   .number .four {
      width: 230px;
      height: 292px;
      display: inline-block;
     /* background-image: url(../img/four.png);*/
      background-repeat: no-repeat;
      background-size: 100%;
      z-index: 19;
      position: relative;
   }
   .number .zero {
    width: 230px;
    height: 292px;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: 0px 20px;
    position: relative;
    z-index: 18;
    -moz-animation: 4s ease 0s normal none infinite zero;
    -moz-transform-origin: center top;
    -webkit-animation: zero 4s infinite ease-in-out;
    -webkit-transform-origin: top;
    -o-animation: 4s ease 0s normal none infinite zero;
    -o-transform-origin: center top;
    -o-animation: zero 4s infinite ease-in-out;
    -o-transform-origin: top;
    -ms-animation: 4s ease 0s normal none infinite zero;
    -ms-transform-origin: center top;
    -ms-animation: zero 4s infinite ease-in-out;
    -ms-transform-origin: top;
    animation: 4s ease 0s normal none infinite zero;
    transform-origin: center top;
    animation: zero 4s infinite ease-in-out;
    transform-origin: top;
   }
   .btn-404 {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    -webkit-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
    border-width: 2px;
    background-color: transparent;
    font-weight: 400;
    opacity: 0.8;
    filter: alpha(opacity=80);
    padding: 8px 16px;
    border-color: #1e8530;
    color: #efefef;
    background-color: #1d9c2a;
   }
   .btn-404:hover{
      border-color: #15771f;
      color: #efefef;
      background-color: #15771f;
   }
</style>


